import { ContentType, ContentTypeMetadata } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { PatternTypeOptions } from '../utils/SelectableOptions';
import MetadataSelectInput from '../workflow-viewer/content/MetadataSelectInput';

interface Props {
  contentType: ContentType;
  contentTypeMetadata: ContentTypeMetadata;
  visible?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  showValidationError?: boolean;
  onInputUpdated?: (sectionId: string, value: any, validationError?: string) => void;
  onValidationError?: (label: string) => (validationError?: string) => void;
}
const ContentTypeMetadataForm: React.FC<Props> = ({
  contentType,
  contentTypeMetadata,
  readonly = false,
  onInputUpdated,
  onValidationError,
}) => {
  const { contentSubType } = contentTypeMetadata;

  let label;
  let contextualHelp;
  let selectionOptions;

  switch (contentType) {
    case ContentType.Pattern:
      label = 'Pattern type';
      contextualHelp = 'pattern-type';
      selectionOptions = PatternTypeOptions;
      break;
    case ContentType.Guide:
    case ContentType.Strategy:
    default:
      return null;
  }

  return (
    <MetadataSelectInput
      sectionId="contentSubType"
      label={label}
      description={'Choose the primary use case for your content.'}
      contextualHelp={contextualHelp}
      readonly={readonly}
      isRequired
      showValidationError={false}
      selectedId={contentSubType}
      selectOptions={selectionOptions}
      onSelectUpdated={onInputUpdated}
      onValidationError={onValidationError && onValidationError(label)}
      stretch
      placeholder={`Select ${label}`}
    />
  );
};

export default ContentTypeMetadataForm;
